export const buttonLandingClickAndHoverEvents = [
  {
    selector: '.mn_buttonLandingMobileChrome .mn_getTheButton',
    click: {
      category: 'ExtensionInstalled',
      action: element => `landing page - ${element.id === 'mn_getTheButtonTop' ? 'top' : 'bottom'}`,
    },
  },
];
